"use client";
import {
  NeoButton,
  NeoDatePicker,
  NeoSelect,
  NeoTextBox
} from "@/components/forms";
import {NeoBreadcrumb, NeoCard, NeoError, NeoHeader} from "@/components/shared";
import {ViewTable} from "@/components/table/datatable/viewtable";
import {useNeoContext} from "@/context/neo/neo.context";
import {AnnouncementUsers} from "@/data";
import {formatDate} from "@/libs/helper";
import {AnnouncementService} from "@/service/announcement.service";
import {yupResolver} from "@hookform/resolvers/yup";
import {CardBody, CardHeader, SelectItem} from "@nextui-org/react";
import {useEffect, useRef, useState} from "react";
import {Controller, useForm} from "react-hook-form";
import toast from "react-hot-toast";
import {AiOutlineLoading} from "react-icons/ai";
import Select from "react-select";
import * as yup from "yup";

interface FormAnnouncements {
  vehicleId: any;
  routeId?: any | undefined;
  type: any;
  fromdate?: any;
  todate?: any;
  info1?: any | undefined;
  info2?: any | undefined;
  info3?: any | undefined;
  custom_msg?: any | undefined;
}

type AnnouncementsFormProps = {
  items: any;
  client: Client;
};

export const AnnouncementsForm: React.FC = () => {
  const mindate = formatDate(new Date());
  const [loading, setLoading] = useState(false);
  const dotedline = ".....................";
  const formdefaultValues: FormAnnouncements = {
    vehicleId: "",
    routeId: "",
    type: "",
    fromdate: "",
    todate: "",
    info1: "",
    info2: "",
    info3: "",
    custom_msg: ""
  };
  const {filterContext} = useNeoContext();
  const [defaultValues, setDefaultvalue] = useState(formdefaultValues);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [Announcements, setAnnouncements] = useState([]);
  const [msgdefaultselect, setMsgDefaultSelect] = useState("");
  const [vehicles, setvehicles] = useState([]);
  const [vehicleroutes, setvehicleroutes] = useState([]);
  const [routes, setroutes] = useState([]);
  const [msgcontents, setmsgcontents] = useState([]);
  const [msgprint, setmsgprint] = useState<string | null>(null);
  const [fromdatevisible, setfromdatevisible] = useState(false);
  const [todatevisible, settodatevisible] = useState(false);
  const [info1visible, setinfo1visible] = useState(false);
  const [info2visible, setinfo2visible] = useState(false);
  const [info3visible, setinfo3visible] = useState(false);
  const [msgformData, setmsgFormData] = useState({
    fromdate: dotedline,
    todate: dotedline,
    info1: dotedline,
    info2: dotedline,
    info3: dotedline,
    type: "",
    custom_msg: ""
  });
  const datas = AnnouncementUsers;
  const [secondsLeft, setSecondsLeft] = useState(0);
  const countdownRef = useRef<NodeJS.Timeout | null>(null);
  const apiTriggerRef = useRef<NodeJS.Timeout | null>(null);
  const [tabledatas, settabledatas] = useState([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const bannedWords = [
    "SEX",
    "GAY",
    "CUM",
    "FAG",
    "JEW",
    "TIT",
    "ASS",
    "FUK",
    "COK",
    "DIK"
  ];
  const validationSchema = yup.object().shape({
    vehicleId: yup.string().required("Please select vehicle"),
    routeId: yup.string(),
    type: yup.string().required("Please select type"),
    custom_msg: yup.string().when("type", {
      is: "Custom Message",
      then: () =>
        yup
          .string()
          .required("Please enter a message")
          .matches(/^[a-zA-Z0-9 .,=-]*$/, "Please enter a valid message")
          .test(
            "no-banned-words",
            "Message contains inappropriate words.",
            value => {
              if (!value) return true; // required already handled
              const lower = value.toLowerCase();
              return !bannedWords.some(word =>
                lower.includes(word.toLowerCase())
              );
            }
          ),
      otherwise: () => yup.string()
    }),
    fromdate: fromdatevisible
      ? yup
          .date()
          .nullable()
          .typeError("Please Enter the Valid Date")
          .transform((value, originalValue) => {
            return originalValue === "" ? null : value;
          })
          .required("Please select from date")
      : yup.string(),
    todate: todatevisible
      ? yup
          .date()
          .nullable()
          .typeError("Please Enter the Valid Date")
          .transform((value, originalValue) => {
            return originalValue === "" ? null : value;
          })
          .required("Please select from date")
          .min(yup.ref("fromdate"), "To Date cannot be before From Date")
      : yup.string(),
    info1: info1visible
      ? yup
          .string()
          .required("Please enter the message")
          .matches(/^[a-zA-Z0-9 .,=-]*$/, "Please enter the valid message")
      : yup.string(),
    info2: info2visible
      ? yup
          .string()
          .required("Please enter the message")
          .matches(/^[a-zA-Z0-9 .,=-]*$/, "Please enter the valid message")
      : yup.string(),
    info3: info3visible
      ? yup
          .string()
          .required("Please enter the message")
          .matches(/^[a-zA-Z0-9 .,=-]*$/, "Please enter the valid message")
      : yup.string()
  });

  const {
    reset,
    resetField,
    register,
    handleSubmit,
    formState: {isSubmitting, isValid, errors},
    control,
    setValue,
    getValues,
    setError,
    clearErrors
  } = useForm<FormAnnouncements>({
    defaultValues,
    mode: "onChange",
    resolver: yupResolver(validationSchema)
  });

  useEffect(() => {
    const sample: any = {
      checkboxcheck: true,
      tableheaders: [
        {
          key: "name",
          label: "Name"
        },
        {
          key: "studentClass",
          label: "Class"
        },
        {
          key: "admissionNo",
          label: "Unique No"
        },
        {
          key: "phone",
          label: "Phone"
        }
      ],
      tablerows: []
    };
    settabledatas(sample);
  }, []);

  useEffect(() => {
    const fetchAnnouncementsAndVehicles = async () => {
      if (vehicles.length === 0 && filterContext.client.institutionId) {
        const instituteId = filterContext.client.institutionId;
        const msgdatas: any = {};
        const vehicledetails: any = [];
        const routedatas: any = {};

        try {
          const response =
            await AnnouncementService.onGetInstVehiclesandMsgs(instituteId);
          if (response?.AnnouncementDatas) {
            const announcementList: any = [...response.AnnouncementDatas];
            /*announcementList.push({
              type: 'Custom Message',
              msg: ''
            });*/
            setAnnouncements(announcementList);
            announcementList.forEach((value: any) => {
              if (!msgdatas[value.type]) {
                msgdatas[value.type] = [];
              }
              msgdatas[value.type].push(value.msg);
            });

            if (Object.keys(msgdatas).length > 0) {
              setmsgcontents(msgdatas);
            }
          }

          if (response?.VehicleDatas) {
            response.VehicleDatas.forEach((value: any) => {
              const vehicle = {
                trackerId: value.trackerId,
                trackerName: value.trackerName
              };
              vehicledetails.push(vehicle);

              if (value.routes) {
                value.routes.forEach((routevalue: any) => {
                  if (!routedatas[value.trackerId]) {
                    routedatas[value.trackerId] = [];
                  }
                  const route = {
                    routeId: routevalue.routeId,
                    routeName: routevalue.routeName
                  };
                  routedatas[value.trackerId].push(route);
                });
              }
            });

            if (vehicledetails.length > 0) {
              setvehicles(vehicledetails);
            }

            if (Object.keys(routedatas).length > 0) {
              setvehicleroutes(routedatas);
            }
          }
        } catch (error) {
          setErrorMessage(
            "Sorry!, We have technical issue please try again later"
          );
        }
      }
    };

    fetchAnnouncementsAndVehicles();
    if (msgformData?.type) {
      custommsg(msgformData.type);
    }
  }, [msgformData, filterContext]);

  const handleReset: any = () => {
    reset();
  };

  const msgfieldReset = () => {
    setValue("fromdate", "");
    setValue("todate", "");
    setValue("info1", "");
    setValue("info2", "");
    setValue("info3", "");
    setfromdatevisible(false);
    settodatevisible(false);
    setinfo1visible(false);
    setinfo2visible(false);
    setinfo3visible(false);
    setmsgprint("");
    clearErrors(["type", "fromdate", "todate", "info1", "info2", "info3"]);
  };

  const VehicleChange = (option: any, name: any) => {
    setValue("type", "");
    var vehicleid: any = option.trackerId;
    setValue(name, vehicleid);
    clearErrors([name]);
    var vehicleroute: any = [];
    if (vehicleid && vehicleroutes[vehicleid]) {
      vehicleroute = vehicleroutes[vehicleid];
    }
    setroutes(vehicleroute);
    setMsgDefaultSelect("");
    msgfieldReset();
    let requestdata = {id: vehicleid, type: 2};
    getusers(requestdata);
  };

  const RouteChange = (e: any) => {
    setValue("type", "");
    setMsgDefaultSelect("");
    setmsgFormData(prevData => ({
      ...prevData,
      type: ""
    }));
    var type: any = e.target.value;
    var name: any = e.target.name;
    setValue(name, type);
    msgfieldReset();
    let vehicleid = getValues("vehicleId");
    if (type !== "") {
      const requestdata = {id: type, type: 1};
      getusers(requestdata);
    } else if (vehicleid !== "") {
      const requestdata = {id: vehicleid, type: 2};
      getusers(requestdata);
    }
  };

  const MsgChange = (option: any, fieldname: any) => {
    msgfieldReset();
    var type: any = option.type;
    var name: any = fieldname;
    setMsgDefaultSelect(type);
    setValue(name, type);
    clearErrors([name]);
    setmsgFormData(prevData => ({
      ...prevData,
      ["fromdate"]: dotedline,
      ["todate"]: dotedline,
      ["info1"]: dotedline,
      ["info2"]: dotedline,
      ["info3"]: dotedline,
      ["type"]: type,
      ["custom_msg"]: ""
    }));
    custommsg(type);
  };

  const custommsg = (type: any) => {
    setValue("custom_msg", "");
    var contents: any = msgcontents;
    var content: any = "";
    const fields: any = [
      "#fromdate",
      "#todate",
      "#textfield1",
      "#textfield2",
      "#textfield3"
    ];
    if (type && contents[type]) {
      content = contents[type][0];
      const contentsplit = content.split(" ");
      fields.map((word: any, index: any) => {
        if (contentsplit.includes(word)) {
          var inputfield: any = "";
          if (word == "#fromdate") {
            inputfield = `${msgformData.fromdate}`;
            setfromdatevisible(true);
          } else if (word == "#todate") {
            inputfield = `${msgformData.todate}`;
            settodatevisible(true);
          } else if (word == "#textfield1") {
            inputfield = `${msgformData.info1}`;
            setinfo1visible(true);
          } else if (word == "#textfield2") {
            inputfield = `${msgformData.info2}`;
            setinfo2visible(true);
          } else if (word == "#textfield3") {
            inputfield = `${msgformData.info3}`;
            setinfo3visible(true);
          }
        }
        const replacedata: any = content.replace(word, inputfield);
        content = replacedata;
      });
    }
    setmsgprint(content);
  };

  const onDateChange = (name: any, event: any) => {
    clearErrors(name);
    setValue(name, event);
    var date = formatDate(event);
    setmsgFormData(prevData => ({
      ...prevData,
      [name]: date
    }));
  };

  const msgreplaceword = (e: any) => {
    const {name, value} = e.target;
    var inputvalue = dotedline;
    if (value) {
      inputvalue = value;
    }
    setmsgFormData(prevData => ({
      ...prevData,
      [name]: inputvalue
    }));
  };

  const onSubmit = async (data: any) => {
    setLoading(true);
    if (countdownRef.current) clearInterval(countdownRef.current);
    if (apiTriggerRef.current) clearTimeout(apiTriggerRef.current);
    setSecondsLeft(10);
    countdownRef.current = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(countdownRef.current!);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    apiTriggerRef.current = setTimeout(async () => {
      var vehicleId = data.vehicleId;
      var routeId = data.routeId;
      var type = data.type;
      var fromdate = data.fromdate;
      var todate = data.todate;
      var info1 = data.info1;
      var info2 = data.info2;
      var info3 = data.info3;

      var msgtype = 2;
      var id = vehicleId;
      var userIds: any = [];
      var message = msgprint;
      if (vehicleId != "" && routeId != "" && selectedRows.length == 0) {
        msgtype = 1;
        id = routeId;
      } else if (selectedRows.length > 0) {
        userIds = selectedRows.map(user => user.userId);
        msgtype = 3;
      }
      if (data.custom_msg) {
        message = data.custom_msg;
      }
      var requestdata = {type: msgtype, id: id, msg: message, userIds: userIds};
      await AnnouncementService.sendsnnouncements(requestdata)
        .then((response: any) => {
          if (response?.data?.status === "success") {
            handleReset();
            resetFormData();
            toast.success(response?.data?.message);
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch(err => {
          toast.error("Sorry!, We have technical issue please try again later");
        })
        .finally(() => {
          setLoading(false);
          setTimeout(() => {
            setErrorMessage(null);
          }, 2000);
        });
    }, 10000);
  };

  const resetFormData = () => {
    setmsgFormData(prevData => ({
      ...prevData,
      vehicleId: "",
      routeId: "",
      type: "",
      fromdate: dotedline,
      todate: dotedline,
      info1: dotedline,
      info2: dotedline,
      info3: dotedline,
      custom_msg: ""
    }));
    setSelectedRows([]);
    settabledatas(prev => ({
      ...prev,
      tablerows: []
    }));
  };

  const handleCancel = () => {
    if (countdownRef.current) clearInterval(countdownRef.current);
    if (apiTriggerRef.current) clearTimeout(apiTriggerRef.current);
    if (secondsLeft > 0) {
      setSecondsLeft(0);
      setLoading(false);
    } else {
      reset();
      resetFormData();
      setmsgprint("");

      setSecondsLeft(0);
      setLoading(false);
    }
  };

  const handleSelectionChange = (rows: any[]) => {
    setSelectedRows(rows);
  };

  const getusers = async (requestdata: any) => {
    settabledatas(prev => ({
      ...prev,
      tablerows: []
    }));
    if (
      requestdata?.id?.toString().trim() !== "" &&
      requestdata?.Type?.toString().trim() !== ""
    ) {
      try {
        const response = await AnnouncementService.getusers(requestdata);
        if (response?.data?.code === 200) {
          if (response?.data?.data) {
            const userRows = response?.data?.data;
            settabledatas(prev => ({
              ...prev,
              tablerows: userRows.data
            }));
          }
        }
      } catch (error) {
        setErrorMessage(
          "Sorry! We have a technical issue. Please try again later."
        );
      }
    }
  };

  return (
    <div className="flex min-h-[calc(100vh-63px)] w-full flex-col p-5">
      <div className="mb-2 flex-row">
        <NeoHeader message="Announcements"></NeoHeader>
      </div>
      <div className="mb-2 flex-row">
        <NeoBreadcrumb menus={breadCrumb}></NeoBreadcrumb>
      </div>
      <div className="grid w-full grid-cols-2 flex-row">
        <div className="">
          <NeoCard className="mb-5">
            <CardHeader></CardHeader>
            <CardBody className="min-h-[calc(100vh-180px)]">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="grid w-full grid-cols-2 gap-9 max-sm:grid-cols-1">
                  <Controller
                    name="vehicleId"
                    control={control}
                    render={({field, fieldState}) => (
                      // <NeoSelect
                      //   {...field}
                      //   label="Vehicle"
                      //   id="vehicleId"
                      //   placeholder="Please select vehicle"
                      //   color={errors.vehicleId ? "danger" : "default"}
                      //   isInvalid={errors.vehicleId ? true : false}
                      //   errorMessage={
                      //     errors.vehicleId && `${errors.vehicleId.message}`
                      //   }
                      //   {...register("vehicleId")}
                      //   onChange={VehicleChange}
                      // >
                      //   {vehicles?.map((e: any, index: number) => (
                      //     <SelectItem key={e.trackerId} value={e.trackerId}>
                      //       {e.trackerName}
                      //     </SelectItem>
                      //   ))}
                      // </NeoSelect>
                      <div className="flex flex-col gap-1">
                        <label
                          // style={style.label}
                          id="aria-label"
                          htmlFor="aria-example-input"
                        >
                          Vehicle
                        </label>
                        <Select
                          name="vehicleId"
                          options={vehicles}
                          getOptionLabel={(e: any) => e.trackerName}
                          getOptionValue={e => e.trackerId.toString()}
                          // defaultValue={vehicleOptions.find(
                          //   opt => opt.value === defaultVehicleSingle
                          // )}
                          value={
                            field.value
                              ? (vehicles.find(
                                  (o: any) =>
                                    String(o.trackerId) === String(field.value)
                                ) ?? null)
                              : null
                          }
                          onChange={selectedOption => {
                            field.onChange(
                              selectedOption
                                ? String(selectedOption.trackerId)
                                : null
                            );
                            VehicleChange(selectedOption, "vehicleId");
                          }}
                          placeholder="Select Vehicle"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: "48px",
                              borderWidth: "2px",
                              borderColor: "#d4d4d8",
                              borderRadius: "12px",
                              paddingLeft: "12px",
                              paddingRight: "12px",
                              boxShadow: "none",
                              fontSize: "14px",
                              color: "#111827",
                              backgroundColor: "white",
                              "&:hover": {
                                borderColor: "#d4d4d8"
                              }
                            }),
                            placeholder: base => ({
                              ...base,
                              color: "#6b7280",
                              fontSize: "14px"
                            }),
                            indicatorSeparator: () => ({
                              display: "none"
                            }),
                            dropdownIndicator: base => ({
                              ...base,
                              color: "#6b7280",
                              paddingRight: "8px"
                            }),
                            // singleValue: base => ({
                            //   ...base,
                            //   color: "#111827"
                            // }),
                            menu: base => ({
                              ...base,
                              borderRadius: "10px",
                              zIndex: 50
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isFocused
                                ? "#e5e7eb"
                                : "white",
                              color: "#111827",
                              padding: "10px 12px",
                              cursor: "pointer",
                              borderRadius: "8px",
                              margin: "2px 4px"
                            })
                          }}
                        />
                        {fieldState.error && (
                          <p className="mt-1 text-xs text-pink-600">
                            {fieldState.error.message}
                          </p>
                        )}
                      </div>
                    )}
                  />
                  <Controller
                    name="routeId"
                    control={control}
                    render={({field}) => (
                      <NeoSelect
                        {...field}
                        label="Route (Optional)"
                        id="routeId"
                        placeholder="Please select route"
                        {...register("routeId")}
                        onChange={RouteChange}
                      >
                        {routes?.map((e: any, index: number) => (
                          <SelectItem key={e.routeId} value={e.routeId}>
                            {e.routeName}
                          </SelectItem>
                        ))}
                      </NeoSelect>
                    )}
                  />
                </div>
                <div className="grid w-full grid-cols-2 gap-9 pt-5 max-sm:grid-cols-1">
                  <Controller
                    name="type"
                    control={control}
                    render={({field, fieldState}) => (
                      // <NeoSelect
                      //   {...field}
                      //   label="Type"
                      //   id="type"
                      //   placeholder="Please select type"
                      //   color={errors.type ? "danger" : "default"}
                      //   isInvalid={errors.type ? true : false}
                      //   errorMessage={errors.type && `${errors.type.message}`}
                      //   selectedKeys={[msgdefaultselect]}
                      //   onChange={MsgChange}
                      // >
                      //   {Announcements?.map((e: any, index: number) => (
                      //     <SelectItem key={e.type} value={e.type}>
                      //       {e.type}
                      //     </SelectItem>
                      //   ))}
                      // </NeoSelect>
                      <div className="flex flex-col gap-1">
                        <label
                          // style={style.label}
                          id="aria-label"
                          htmlFor="aria-example-input"
                        >
                          Type
                        </label>
                        <Select
                          name="type"
                          options={Announcements}
                          getOptionLabel={(e: any) => e.type}
                          getOptionValue={e => e.type.toString()}
                          // defaultValue={vehicleOptions.find(
                          //   opt => opt.value === defaultVehicleSingle
                          // )}
                          value={
                            field.value
                              ? (Announcements.find(
                                  (o: any) =>
                                    String(o.type) === String(field.value)
                                ) ?? null)
                              : null
                          }
                          onChange={selectedOption => {
                            field.onChange(
                              selectedOption
                                ? String(selectedOption.type)
                                : null
                            );
                            MsgChange(selectedOption, "type");
                          }}
                          placeholder="Select Type"
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              minHeight: "48px",
                              borderWidth: "2px",
                              borderColor: "#d4d4d8",
                              borderRadius: "12px",
                              paddingLeft: "12px",
                              paddingRight: "12px",
                              boxShadow: "none",
                              fontSize: "14px",
                              color: "#111827",
                              backgroundColor: "white",
                              "&:hover": {
                                borderColor: "#d4d4d8"
                              }
                            }),
                            placeholder: base => ({
                              ...base,
                              color: "#6b7280",
                              fontSize: "14px"
                            }),
                            indicatorSeparator: () => ({
                              display: "none"
                            }),
                            dropdownIndicator: base => ({
                              ...base,
                              color: "#6b7280",
                              paddingRight: "8px"
                            }),
                            // singleValue: base => ({
                            //   ...base,
                            //   color: "#111827"
                            // }),
                            menu: base => ({
                              ...base,
                              borderRadius: "10px",
                              zIndex: 50
                            }),
                            option: (base, state) => ({
                              ...base,
                              backgroundColor: state.isFocused
                                ? "#e5e7eb"
                                : "white",
                              color: "#111827",
                              padding: "10px 12px",
                              cursor: "pointer",
                              borderRadius: "8px",
                              margin: "2px 4px"
                            })
                          }}
                        />
                        {fieldState.error && (
                          <p className="mt-1 text-xs text-pink-600">
                            {fieldState.error.message}
                          </p>
                        )}
                      </div>
                    )}
                  />
                </div>
                <div
                  className={`grid w-full grid-cols-2 gap-9 pt-5 max-sm:grid-cols-1 ${fromdatevisible || todatevisible ? "block" : "hidden"}`}
                >
                  <div className={fromdatevisible ? "block" : "hidden"}>
                    <Controller
                      name="fromdate"
                      control={control}
                      render={({
                        field: {ref, value, onChange, ...fieldRest}
                      }) => (
                        <NeoDatePicker
                          {...fieldRest}
                          label="From Date"
                          placeholder="Please select from date"
                          errorMessage={
                            errors.fromdate && `${errors.fromdate.message}`
                          }
                          minDate={mindate}
                          value={value}
                          handleDateChange={(e: any) => {
                            onChange(e);
                            onDateChange("fromdate", e);
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className={todatevisible ? "block" : "hidden"}>
                    <Controller
                      name="todate"
                      control={control}
                      render={({
                        field: {ref, value, onChange, ...fieldRest}
                      }) => (
                        <NeoDatePicker
                          {...fieldRest}
                          label="To Date"
                          placeholder="Please select to date"
                          errorMessage={
                            errors.todate && `${errors.todate.message}`
                          }
                          minDate={mindate}
                          value={value}
                          handleDateChange={(e: any) => {
                            onChange(e);
                            onDateChange("todate", e);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
                <div
                  className={`grid w-full grid-cols-2 gap-9 pt-5 max-sm:grid-cols-1 ${info1visible || info2visible || info3visible ? "block" : "hidden"}`}
                >
                  <div className={info1visible ? "block" : "hidden"}>
                    <Controller
                      name="info1"
                      control={control}
                      render={({field}) => (
                        <NeoTextBox
                          {...field}
                          label="Info"
                          placeholder="Please enter message"
                          id="info1"
                          color={errors.info1 ? "danger" : "default"}
                          isInvalid={errors.info1 ? true : false}
                          errorMessage={
                            errors.info1 && `${errors.info1.message}`
                          }
                          autoComplete="off"
                          {...register("info1")}
                          onChange={e => {
                            field.onChange(e);
                            msgreplaceword(e);
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className={info2visible ? "block" : "hidden"}>
                    <Controller
                      name="info2"
                      control={control}
                      render={({field}) => (
                        <NeoTextBox
                          {...field}
                          label="Info"
                          placeholder="Please enter message"
                          id="info2"
                          color={errors.info2 ? "danger" : "default"}
                          isInvalid={errors.info2 ? true : false}
                          errorMessage={
                            errors.info2 && `${errors.info2.message}`
                          }
                          autoComplete="off"
                          {...register("info2")}
                          onChange={e => {
                            field.onChange(e);
                            msgreplaceword(e);
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className={info3visible ? "block" : "hidden"}>
                    <Controller
                      name="info3"
                      control={control}
                      render={({field}) => (
                        <NeoTextBox
                          {...field}
                          label="Info"
                          placeholder="Please enter message"
                          id="info3"
                          color={errors.info3 ? "danger" : "default"}
                          isInvalid={errors.info3 ? true : false}
                          errorMessage={
                            errors.info3 && `${errors.info3.message}`
                          }
                          autoComplete="off"
                          {...register("info3")}
                          onChange={e => {
                            field.onChange(e);
                            msgreplaceword(e);
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="grid w-full grid-cols-1 gap-9 pt-5 max-sm:grid-cols-1">
                  <h4>Message</h4>
                </div>
                {msgformData?.type !== "Custom Message" ? (
                  <div className="grid w-full grid-cols-1 gap-9 pl-5 pt-1 max-sm:grid-cols-1">
                    <p>{msgprint}</p>
                  </div>
                ) : (
                  <div className="grid w-full grid-cols-1 pl-2 pt-1 max-sm:grid-cols-1">
                    <Controller
                      name="custom_msg"
                      control={control}
                      render={({field}) => (
                        <>
                          <textarea
                            {...field}
                            className="w-full rounded-[17px] border-2 p-3 shadow-none hover:border-gray-600 focus:outline-none focus:ring-[#888888]"
                            placeholder="Please enter message"
                            rows={4}
                            id="custom_msg"
                            color={errors.custom_msg ? "danger" : "default"}
                            autoComplete="off"
                            {...register("custom_msg")}
                          />
                          {typeof errors.custom_msg?.message === "string" && (
                            <p className="mt-1 text-sm text-red-500">
                              {errors.custom_msg.message}
                            </p>
                          )}
                        </>
                      )}
                    />
                  </div>
                )}
                {errorMessage ? (
                  <NeoError message={errorMessage}></NeoError>
                ) : null}
                <div className="flex items-center justify-end p-4">
                  <NeoButton
                    className="mx-5 mt-2"
                    type="submit"
                    disabled={loading}
                    isLoading={loading}
                    color="black"
                    spinner={
                      loading ? (
                        <AiOutlineLoading className="animate-spin h-5 w-5" />
                      ) : null
                    }
                  >
                    {loading
                      ? secondsLeft > 0
                        ? `Submitting (${secondsLeft}s)`
                        : "Submit"
                      : "Submit"}
                  </NeoButton>
                  <NeoButton
                    className="mt-2"
                    type="button"
                    color="white"
                    onClick={handleCancel}
                  >
                    Cancel
                  </NeoButton>
                </div>
              </form>
            </CardBody>
          </NeoCard>
        </div>
        <div className="ml-2">
          <NeoCard className="mb-5">
            <CardHeader>Users Details</CardHeader>
            <CardBody className="min-h-[calc(100vh-205px)]">
              <div className="flex-row">
                <ViewTable
                  tabledatas={tabledatas}
                  onSelectionRow={handleSelectionChange}
                />
              </div>
            </CardBody>
          </NeoCard>
        </div>
      </div>
    </div>
  );
};
const breadCrumb = [
  {
    link: "/operations",
    label: "Operations"
  },
  {
    link: "",
    label: "Announcement"
  }
];
